import App from 'antd/lib/app';
import { useSavedFilterListQuery } from '../../domain/saved-filters/queries';
import { SavedFilterSubType } from './saved-filter/interface';

export const useSavedFiltersList = (subType: SavedFilterSubType) => {
    const { notification } = App.useApp();

    const { data, isLoading, isError, error } = useSavedFilterListQuery(
        { subType },
        {
            enabled: true,
            keepPreviousData: false,
        }
    );

    if (isError) {
        notification.error({
            message: 'Error loading saved filters',
            description: error instanceof Error ? error.message : 'An unknown error occurred',
        });
    }

    return {
        savedFilters: data || [],
        isLoading,
    };
};
